import { createContext, useContext } from 'react';

interface AuthContextType {
  jwtToken: string;
  setToken: (token: any) => void;
}

export const AuthContext = createContext<AuthContextType>(null!);
export const useAuth = (): AuthContextType => useContext(AuthContext);
